import { MiladiToShamsi } from "./Miladi_To_Shamsi";

export const formatDate = (date) => {
  if (date) {
    const newFormat = `${date?.year}-${date?.month}-${date?.day}`;
    return newFormat;
  }
  return null;
};

export const reverseFormatDate = (date) => {
  if (date) {
    const formatDate = date?.split("-");
    const year = formatDate[0];
    const month = formatDate[1];
    const day = formatDate[2];
    const newDate = {
      year,
      month,
      day,
    };
    return newDate;
  } else {
    return;
  }
};

export const formatDatePicker = (date) => {
  const miladiToSh = MiladiToShamsi(date);
  const oldFormat = miladiToSh?.split("/");
  const newFormat = {
    year: oldFormat[0],
    month: oldFormat[1],
    day: oldFormat[2],
  };
  return newFormat;
};

export const datePicker = (date) => {
  if (date) {
    const miladiToShamsi = MiladiToShamsi(date);
    const newFormat = miladiToShamsi?.split("/");
    const year = newFormat[0];
    const month = newFormat[1];
    const day = newFormat[2];

    return {
      year,
      month,
      day,
    };
  }
};
